import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function ScrollStrip({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setCanLeft(el.scrollLeft > 2);
    setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 2);
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.addEventListener('scroll', update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => { el.removeEventListener('scroll', update); ro.disconnect(); };
  }, [update]);

  useEffect(() => { update(); }, [children, update]);

  // const scrollBy = (dx: number) => ref.current?.scrollBy({ left: dx, behavior: 'smooth' });
  const scrollBy = (direction: number) => {
  const el = ref.current;
  if (!el) return;

  const items = Array.from(el.children) as HTMLElement[];
  if (!items.length) return;

  const currentScroll = el.scrollLeft;

  if (direction > 0) {
    const nextItem = items.find(
      (item) => item.offsetLeft - el.offsetLeft > currentScroll + 2
    );

    if (nextItem) {
      el.scrollTo({
        left: nextItem.offsetLeft - el.offsetLeft,
        behavior: 'smooth',
      });
    }
  } else {
    const previousItem = [...items].reverse().find(
      (item) => item.offsetLeft - el.offsetLeft < currentScroll - 2
    );

    if (previousItem) {
      el.scrollTo({
        left: previousItem.offsetLeft - el.offsetLeft,
        behavior: 'smooth',
      });
    } else {
      el.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }
};

  return (
   <div style={{
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  width: '100%',
  gap: 6
}}>
     <div style={{ width: 30, flexShrink: 0 }}>
  {canLeft && (
    <button
      type="button"
      // onClick={() => scrollBy(-300)}
      onClick={() => scrollBy(-1)}
      aria-label="Scroll left"
      style={arrow}
    >
      <ChevronLeft size={18} />
    </button>
  )}
</div>
      <div
        ref={ref}
        onWheel={(e) => {
          // mouse wheel scrolls the strip sideways
          if (ref.current && Math.abs(e.deltaY) > Math.abs(e.deltaX)) ref.current.scrollLeft += e.deltaY;
        }}
        style={{ display: 'flex', gap: 10, overflowX: 'auto', scrollbarWidth: 'none', minWidth: 0, flex: 1 }}
      >
        {children}
      </div>
    <div style={{ width: 30, flexShrink: 0 }}>
  {canRight && (
    <button
      type="button"
      // onClick={() => scrollBy(300)}
      onClick={() => scrollBy(1)}
      aria-label="Scroll right"
      style={arrow}
    >
      <ChevronRight size={18} />
    </button>
  )}
</div>
    </div>
  );
}

const arrow: React.CSSProperties = {
  
  width: 28, height: 28, borderRadius: '50%', border: '1px solid #e2e8f0',
  background: '#fff', boxShadow: '0 2px 6px rgba(0,0,0,.15)', cursor: 'pointer',
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0,
};
